import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
  cursor?: number;
  before?: string;
};

export const meGetVoteTokens = createQueryFn(
  QueryNameSpace.meGetVoteTokens,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.meGetVoteTokens({
      ...params,
      pagecursor: pageParam as [string, string],
    });

    return res;
  },
);
